export default __webpack_public_path__ + "media/1.0325f.png";